<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <div class="mr-2">
      <p>{{ name }}</p>
      <p v-if="hours_scoped">
        Estimated hours: <span class="font-bold">{{ hours_scoped }}</span>
      </p>
      <p v-if="hours_recorded">
        Recorded hours: <span class="font-bold">{{ hours_recorded }}</span>
      </p>
      <template v-if="customer">
        <p v-if="customer.name">{{ customer.name }}</p>
        <template v-if="customer.places && customer.places.length">
          <p>{{ customer.places[0].address_1 }}</p>
          <p>
            {{ customer.places[0].cityStateZip }}
            <a
              class="ml-1 text-red hover-bold"
              :href="generateGoogleMapsUrl(customer.places[0])"
            >
              <i class="fal fa-map-marker-alt"></i>
            </a>
          </p>
        </template>
      </template>
    </div>
    <template #bottom>
      <div class="px-4 pb-4" v-if="files && files.length">
        <bdg-files-list :items="files" />
      </div>
      <!-- TODO: Add "Crew members present/crew leader present stuff -->
      <!-- TODO: Figure out if tasks have 3 completion states or just 2, then put them in here -->
    </template>
  </list-view-cell>
</template>

<script>
import ListViewCell from "../ListViewCell";
import { Contact } from "../../../../models/Contact";
import BdgFilesList from "../../../files-list/BdgFilesList";
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import UpdateTaskForm from "../../../../forms/UpdateTaskForm";
import { Contract } from "../../../../models/Contract";

export default {
  name: "TaskCell",
  components: { BdgFilesList, ListViewCell },
  props: {
    id: Number,
    user_id: Number,
    contract_id: Number,
    work_scope_id: Number,
    work_scope_item_id: Number,
    name: String,
    status: String,
    crew_leader_hours: Number,
    crew_member_hours: Number,
    crew_member_present: Boolean,
    hours_scoped: Number,
    hours_recorded: Number,
    customer: Contact,
    files: {
      type: Array,
      default: () => []
    },
    contract: Contract
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("Update", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: UpdateTaskForm,
            createEditComponentData: {
              task: {
                id: this.id,
                user_id: this.user_id,
                contract_id: this.contract_id,
                work_scope_id: this.work_scope_id,
                work_scope_item_id: this.work_scope_item_id,
                name: this.name,
                status: this.status,
                hours_scoped: this.hours_scoped,
                hours_recorded: this.hours_recorded,
                customer: this.customer,
                files: this.files,
                contract: this.contract
              }
            },
            createEditComponentIsShown: true
          });
        })
      ]
    };
  }
};
</script>

<style scoped></style>
